export enum EButtonVariant {
  BUTTON = 'button',
  LINK = 'link',
}

export enum EButtonStyleVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SPECIAL = 'special',
}
